import React from "react";
import { NavLink } from "react-router-dom";
import { NavLinkStyled, SectionContainer } from "./shared.styled";
import { HOME_URL, FOR_BUYERS_URL, FOR_VENDORS_URL, ORGANIZATION_CREATE_URL, RESOURCES_URL } from "../utlities/core.constants";
import useSiteNavLinks from "../hooks/useSiteNavLinks.hook";

export default function ResourceSection() {
  const {
    buyersNavLabel,
    showForVendorsLink,
    showAcrEditorLink,
    acrEditorUrl,
    myOrganizationMenuItems,
    showSuperUserToolsLink,
    superUserToolsUrl,
  } = useSiteNavLinks();

  // Add Organization stays in the header My Organization menu. It is omitted here so the
  // bottom bar does not grow a one-off admin action next to the site sections.
  const bottomNavItems = myOrganizationMenuItems.filter((item) => item.to !== ORGANIZATION_CREATE_URL);

  return (
    <div className="py-4 bg-primary text-white">
      <SectionContainer className="p-0 ">
      <nav className="flex font-bold" aria-label="Site sections">
        <NavLinkStyled className="pb-0">
          <NavLink to={HOME_URL}>
            Home
          </NavLink>
        </NavLinkStyled>
        <NavLinkStyled className="pb-0">
          <NavLink to={FOR_BUYERS_URL}>
            {buyersNavLabel}
          </NavLink>
        </NavLinkStyled>
        {showForVendorsLink ? (
          <NavLinkStyled className="pb-0">
            <NavLink to={FOR_VENDORS_URL}>
              For Vendors
            </NavLink>
          </NavLinkStyled>
        ) : null}
        {bottomNavItems.map((item) => (
          <NavLinkStyled key={item.to} className="pb-0">
            <NavLink to={item.to}>
              {item.label}
            </NavLink>
          </NavLinkStyled>
        ))}
        {showAcrEditorLink ? (
          <NavLinkStyled className="pb-0">
            <NavLink to={acrEditorUrl}>
              ACR Editor
            </NavLink>
          </NavLinkStyled>
        ) : null}
        <NavLinkStyled className="pb-0">
          <NavLink to={RESOURCES_URL}>
            Resources
          </NavLink>
        </NavLinkStyled>
        {showSuperUserToolsLink ? (
          <NavLinkStyled className="pb-0">
            <NavLink to={superUserToolsUrl}>
              Superuser Tools
            </NavLink>
          </NavLinkStyled>
        ) : null}
      </nav>
      </SectionContainer>
    </div>
  );
}
